import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EmailTemplateService {
  constructor(private http: HttpClient) { }

  async load(path: string): Promise<string> {
    return firstValueFrom(this.http.get(path, { responseType: 'text' }));
  }

  applyReplacements(template: string, replacements?: Record<string, string>): string {
    if (!replacements) return template;
    let out = template;
    for (const [key, value] of Object.entries(replacements)) {
      // replace all occurrences safely
      out = out.split(key).join(value);
    }
    return out;
  }
}
